// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"7a39a922","110":"03cec6cc","371":"2e2a9e02","537":"06086570","621":"c83a9009","868":"96f57bb1","957":"78b2be34","978":"5bcc6573"}[chunkId] + ".chunk.css";
};